import React from 'react';
import Sidebar from '../Sidebar';
import CorporatePosts from '../CorporatePosts';
import CurrentSelected from '../CurrentSelected';
import useSettingsContext from '../../context/useSettingsContext';
import useUtilities from '../../methods/utilities/useUtilities';

function LayoutCorporate() {
  const {sidebarClassName} = useUtilities();
  const {displaySelected, displaySidebar} = useSettingsContext();
  let sidebarLeft, sidebarRight, sidebarTop, sidebarContent;

  if (displaySelected) {
    sidebarTop = <CurrentSelected></CurrentSelected>
  }

  if (displaySidebar !== 'false') {
    sidebarContent = <Sidebar
      sidebarLeft={sidebarLeft}
      sidebarRight={sidebarRight}
      autoLoadFilters={true}
    >
    </Sidebar>
  }

  return (
    <div className={`app-layout layout-corporate ${sidebarClassName()}`}>
      {sidebarTop}
      {sidebarContent}
    
      <CorporatePosts></CorporatePosts>
    </div>
  )
}

export default LayoutCorporate;

